const DrupalOAuth = require("./DrupalOAuth");

module.exports = async function submitLogin(authContext, formData) {
	const [state, dispatch] = authContext;
	const auth = new DrupalOAuth(state);
	const token = await auth.loginUser(formData, "authorization_code");
	if (token && token.token) {
		dispatch({
			type: "AUTHENTICATE_USER",
		});
		return true;
	} else {
		//TODO: inform the user that they failed to log in.
		console.error("failed to login");
		return false;
	}
};
